import React, { useState } from 'react';
import { X } from 'lucide-react';

const RelationDescriptionModal = ({ isOpen, onClose, onSubmit, topicName, basketName }) => {
  const [description, setDescription] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(description);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Describe the Relationship</h3>
          <button onClick={() => onClose()} className="text-gray-500 hover:text-gray-700">
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <p className="text-sm text-gray-600 mb-4">
            Describe how "{topicName}" relates to "{basketName}" (optional)
          </p>
          
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter a description of how this topic relates to the selected basket..."
            className="w-full h-32 p-3 border rounded-lg focus:ring-2 focus:ring-cranberry-700 focus:border-transparent"
          />
          
          <div className="flex justify-end gap-3 mt-4">
            <button
              type="button"
              onClick={() => onSubmit('')}
              className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
            >
              Skip
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-cranberry-700 text-white rounded-lg hover:bg-cranberry-600 text-sm"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RelationDescriptionModal; 